import { getCameraData } from "@web/utils/camera/getCameraData";
import { GetStaticPaths, GetStaticProps } from "next";
import { CameraData } from "@web/types/CameraData";
import { cameraNameForUrl } from "@web/utils/camera/cameraNameForUrl";
import { CameraPage } from "@web/pages/cameras/CameraPage";

export const getStaticPaths: GetStaticPaths = async () => {
  const cameraDataArray = await getCameraData();
  const paths = cameraDataArray
    .filter((data) => data.Verified)
    .map((data) => ({
      params: { "camera-name": cameraNameForUrl(data["Camera Name"]) },
    }));
  return {
    fallback: false,
    paths,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const cameraDataArray = await getCameraData();
  const cameraName = params!["camera-name"] as string;
  const cameraData = cameraDataArray.filter(
    (row) => cameraNameForUrl(row["Camera Name"]) === cameraName && row.Verified
  )[0];
  return {
    props: {
      cameraData,
    },
  };
};

type Props = {
  cameraData: CameraData;
};

export default function Camera({ cameraData }: Props) {
  return <CameraPage cameraData={cameraData} />;
}
